import { Component, OnInit, ViewEncapsulation, input, output, signal } from '@angular/core';
import { SOCIAL_NETWORKS } from '../../../../account-v2/src/app/api/socialNetwork';
import { CapitalizePipe } from '../../advocacy-group/contest-sheets/contest-sheets.pipes';

/**
 * Broadcast "choose network" step — renders the social-network share links and
 * emits the picked network. PRESERVE-BUGS: v1's `$onChange` typo meant the list
 * computed once at init and never refreshed, so we compute only in ngOnInit.
 */
@Component({
    selector: 'ft-broadcast-choose-network-ng',
    imports: [CapitalizePipe],
    encapsulation: ViewEncapsulation.None,
    templateUrl: './ft-broadcast-choose-network.component.html',
    styleUrls: ['./ft-broadcast-choose-network.component.scss'],
})
export class FtBroadcastChooseNetworkComponent implements OnInit {
    readonly sharedTo = input<any>();
    readonly openShareModal = output<any>();

    protected readonly socialNetworks = signal<any[] | undefined>(undefined);

    ngOnInit(): void {
        if (!!this.sharedTo()) {
            this.socialNetworks.set(
                SOCIAL_NETWORKS.map((n) =>
                    Object.assign({}, n, { isSharedTo: !!this.sharedTo().find((s: any) => s == n.type) }),
                ),
            );
        }
    }

    protected shareTo(network: any): void {
        this.openShareModal.emit(network);
    }
}
